const INFINITY_SCRIPT_ID = "oracle-infinity-script";
const INFINITY_SCRIPT_SRC =
  "https://d.oracleinfinity.io/infy/acs/account/{Account GUID}/js/{Tag ID}/odc.js?_ora.config=analytics:test";

export function loadInfinity() {
  if (
    typeof window === "undefined" ||
    window.ENV?.CUSTOMER?.toLowerCase() !== "ambarella"
  ) {
    return;
  }

  const existingScript = document.getElementById(INFINITY_SCRIPT_ID);

  if (existingScript?.getAttribute("src") === INFINITY_SCRIPT_SRC) {
    return;
  }

  existingScript?.remove();

  const script = document.createElement("script");

  script.id = INFINITY_SCRIPT_ID;
  script.src = INFINITY_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
}
